module.exports = __webpack_public_path__ + "static/media/MADRS.4181d58f.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/MADRS.pdf
// module id = 142
// module chunks = 0